import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { LangProvider } from "@/context/LangContext";
import { ContentI18nProvider } from "@/context/ContentI18n";
import { PlayerProvider } from "@/context/PlayerContext";
import { Footer } from "@/components/Footer";
import { AmbientMusic } from "@/components/AmbientMusic";
import Room from "@/pages/Room";
import Admin from "@/pages/Admin";
import Submit from "@/pages/Submit";
import Workshop from "@/pages/Workshop";
import WorkshopProject from "@/pages/WorkshopProject";
import EveningBlessing from "@/pages/EveningBlessing";
import Dedications from "@/pages/Dedications";
import DedicationView from "@/pages/DedicationView";
import ListenTogether from "@/pages/ListenTogether";
import PothKamare from "@/pages/PothKamare";
import StoryKamare from "@/pages/StoryKamare";
import WadihitiGayakayo from "@/pages/WadihitiGayakayo";
import BhavanaKamare from "@/pages/BhavanaKamare";
import WadaBaila from "@/pages/WadaBaila";
import VoiceStudio from "@/pages/VoiceStudio";
import VoiceView from "@/pages/VoiceView";
import Remembrance from "@/pages/Remembrance";
import MemorialView from "@/pages/MemorialView";
import BookDetail from "@/pages/BookDetail";
import CollectionView from "@/pages/CollectionView";
import Membership from "@/pages/Membership";
import Invite from "@/pages/Invite";
import Poems from "@/pages/Poems";
import Karaoke from "@/pages/Karaoke";
import PostKit from "@/pages/PostKit";
import Partner from "@/pages/Partner";
import Ideas from "@/pages/Ideas";
import WishWall from "@/pages/WishWall";
import Heritage from "@/pages/Heritage";
import Serenbity from "@/pages/Serenbity";
import About from "@/pages/About";
import Ambassadors from "@/pages/Ambassadors";

function App() {
  return (
    <LangProvider>
      <ContentI18nProvider>
        <PlayerProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Navigate to="/rooms/sindu-kamare" replace />} />
              <Route path="/rooms/sindu-kamare" element={<Room />} />
              <Route path="/rooms/sindu-kamare/submit" element={<Submit />} />
              <Route path="/rooms/sindu-kamare/workshop" element={<Workshop />} />
              <Route path="/rooms/sindu-kamare/workshop/:id" element={<WorkshopProject />} />
              <Route path="/rooms/sindu-kamare/evening" element={<EveningBlessing />} />
              <Route path="/rooms/sindu-kamare/dedications" element={<Dedications />} />
              <Route path="/rooms/sindu-kamare/dedication/:id" element={<DedicationView />} />
              <Route path="/rooms/sindu-kamare/listen" element={<ListenTogether />} />
              <Route path="/rooms/sindu-kamare/listen/:code" element={<ListenTogether />} />
              <Route path="/rooms/sindu-kamare/collection/:id" element={<CollectionView />} />
              <Route path="/rooms/poth-kamare" element={<PothKamare />} />
              <Route path="/rooms/poth-kamare/:id" element={<BookDetail />} />
              <Route path="/rooms/story-kamare" element={<StoryKamare />} />
              <Route path="/rooms/story-kamare/:id" element={<BookDetail />} />
              <Route path="/rooms/wadihiti-gayakayo" element={<WadihitiGayakayo />} />
              <Route path="/rooms/bhavana-kamare" element={<BhavanaKamare />} />
              <Route path="/rooms/wada-baila" element={<WadaBaila />} />
              <Route path="/rooms/sindu-kamare/voice" element={<VoiceStudio />} />
              <Route path="/voice/:id" element={<VoiceView />} />
              <Route path="/remembrance" element={<Remembrance />} />
              <Route path="/remembrance/:id" element={<MemorialView />} />
              <Route path="/rooms/sindu-kamare/admin" element={<Admin />} />
              <Route path="/rooms/sindu-kamare/membership" element={<Membership />} />
              <Route path="/invite" element={<Invite />} />
              <Route path="/rooms/sindu-kamare/poems" element={<Poems />} />
              <Route path="/rooms/sindu-kamare/karaoke" element={<Karaoke />} />
              <Route path="/rooms/sindu-kamare/kit" element={<PostKit />} />
              <Route path="/rooms/sindu-kamare/partner" element={<Partner />} />
              <Route path="/rooms/sindu-kamare/ideas" element={<Ideas />} />
              <Route path="/rooms/sindu-kamare/friends" element={<WishWall />} />
              <Route path="/rooms/sindu-kamare/heritage" element={<Heritage />} />
              <Route path="/rooms/sindu-kamare/serenbity" element={<Serenbity />} />
              <Route path="/rooms/sindu-kamare/about" element={<About />} />
              <Route path="/rooms/sindu-kamare/ambassadors" element={<Ambassadors />} />
              <Route path="*" element={<Navigate to="/rooms/sindu-kamare" replace />} />
            </Routes>
            <Footer />
            <AmbientMusic />
          </BrowserRouter>
          <Toaster position="top-center" richColors closeButton />
        </div>
      </PlayerProvider>
      </ContentI18nProvider>
    </LangProvider>
  );
}

export default App;
